/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SortDirection = core.serialization.enum_(["asc", "desc"]);
